// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// This is necessary to work stand-alone, but causes problems when embedded in the main site.
// We need to work out how to handle that during development, but for now it's commented out.
// import '../node_modules/bootstrap/dist/css/bootstrap.css'
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import { VueCodeHighlighter as CodeHighlighter } from "vue-code-highlighter";

import "./assets/css/ccike.css";

import { createApp } from "vue";
import App from "./App";
import router from "./router";

import BootstrapVue3 from "bootstrap-vue-3";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCheck,
  faArrowUpShortWide,
  faArrowDownShortWide,
  faMinus,
  faXmark,
  faWindowClose,
  faAngleUp,
  faAngleDown,
  faMagnifyingGlass,
  faArrowRight,
  faArrowLeft,
  faArrowDownLong,
  faSignInAlt,
  faHouse,
  faFileLines,
  faDownload,
  faPlusCircle,
  faMinusCircle,
  faCalendar,
  faArrowUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faCheck);
library.add(faArrowUpShortWide);
library.add(faArrowDownShortWide);
library.add(faMinus);
library.add(faXmark);
library.add(faWindowClose);
library.add(faAngleUp);
library.add(faAngleDown);
library.add(faMagnifyingGlass);
library.add(faArrowRight);
library.add(faArrowLeft);
library.add(faArrowDownLong);
library.add(faSignInAlt);
library.add(faHouse);
library.add(faFileLines);
library.add(faDownload);
library.add(faPlusCircle);
library.add(faMinusCircle);
library.add(faCalendar);
library.add(faArrowUpRightFromSquare);

const app = createApp(App);
app.use(router);
app.use(BootstrapVue3);

app.component("font-awesome-icon", FontAwesomeIcon);
app.component("code-highlighter", CodeHighlighter);
app.component("open-dropdown-icon", {
  template: '<font-awesome-icon class="" icon="angle-down"/>',
});
app.component("close-dropdown-icon", {
  template: '<font-awesome-icon class="" icon="angle-up"/>',
});

app.mount("#app");
